window.theme = window.theme || {}, window.theme.modules = window.theme.modules || {}, theme.modules.mediaTextList = theme.modules.mediaTextList || {
  initialized: !1,
  mediaTextListButtons: document.querySelectorAll(".media-text-list__content-button"),
  initMediaTextFeature: function () {
    theme.modules.mediaTextList.initialized || (theme.modules.mediaTextList.mediaTextListButtons.forEach(theme.modules.mediaTextList.setMediaTextFeatureListeners), theme.modules.mediaTextList.initialized = !0)
  },
  setMediaTextFeatureListeners: function (e, t, i) {
    e.addEventListener("click", (function () {
      let t = e.closest(".media-text-list__foreground").querySelectorAll(".text-item"),
        i = e.dataset.id;
      t.forEach(theme.modules.mediaTextList.deactivateMediaTextFeature), e.closest(".text-item").classList.add("item--active"), document.querySelector(`.media-text-list__content-descriptions [data-id="${i}"]`).classList.add("item--active")
    }), !1), e.addEventListener("focus", (function () {
      let t = e.closest(".media-text-list__foreground").querySelectorAll(".text-item"),
        i = e.dataset.id;
      t.forEach(theme.modules.mediaTextList.deactivateMediaTextFeature), e.closest(".text-item").classList.add("item--active"), document.querySelector(`.media-text-list__content-descriptions [data-id="${i}"]`).classList.add("item--active")
    }), !1)
  },
  deactivateMediaTextFeature: function (e, t, i) {
    e.classList.remove("item--active")
  }
}, theme.modules.mediaTextList.initMediaTextFeature();